/*
 * CategryPropertyMoal.jsx
 *
 * Speakers
 * Created by Mahdi Yousefpour on Sat Feb 11 2023 mys Company
 */

import { useEffect, useState } from 'react'
import { localization } from '../../config/localize/localizable'
import { useCategoryPropertyHooks } from '../../modules/categoryProperty/hooks/useCategoryPropertyHooks'
import DefaultSelect from '../element/DefaultSelect'
import FormikTextField from '../element/FormikTextField'
import BaseModal from './BaseModal'

const CategryPropertyModal = ({ title = '', category, property, visible, complete }) => {
    //
    // MARK: METHODS
    const [visibleModal, setVisibleModal] = useState(visible)
    const types = [
        { title: localization.text, value: 'TEXT' },
        { title: localization.number, value: 'NUMBER' },
        { title: localization.checkbox, value: 'CHECKBOX' },
        { title: localization.selective, value: 'SELECT' },
    ]

    let item = {}
    const service = useCategoryPropertyHooks()

    const loaded = useEffect(() => {
        setVisibleModal(visible)
    }, [visible])

    const handleClick = () => {
        debugger
        item.categoryId = category.id
        item.propertyId = property.id
        service.post(item, {
            onSuccess: async () => {
                if (complete) complete(true)
                setVisibleModal(true)
            },
        })
    }

    const handleCancel = () => {
        complete(false)
        setVisibleModal(true)
    }
    return (
        <div
            id=""
            className={`fixed top-0 right-0 bottom-0 left-0 h-screen w-screen bg-black bg-opacity-60  justify-center  ${visibleModal ? 'hidden' : ''}`}
            onClick={(e) => {
                //setVisibleModal(true)
            }}
        >
            <div className="w-2/3 md:w-1/3 m-auto relative bg-white  rounded my-32 mb-3">
                <div className=" border-b mb-4 grid grid-cols-7 bg-black bg-opacity-70 rounded-tl rounded-tr">
                    <span className="h-8 inline-block col-span-6 pt-1 pr-2 text-white">{title}</span>
                    <div className="w-full col-span-1 text-left pt-1 pl-2" dir="ltr">
                        <div className="w-5 h-5  text-center rounded-full text-white select-none cursor-pointer" onClick={handleCancel}>
                            x
                        </div>
                    </div>
                </div>
                <div className="grid grid-cols-1 p-2 pt-1 ">
                    <label className="w-full outline-none text-sm">{localization.category}</label>
                    <label className="w-full border border-gray-100 rounded shadow-sm p-2 outline-none mb-3 ">{category?.title}</label>
                    <label className="w-full outline-none text-sm">{localization.property}</label>
                    <label className="w-full border border-gray-100 rounded shadow-sm p-2 outline-none mb-3 ">{property?.title}</label>
                    <FormikTextField
                        name="section"
                        placeHolder={localization.section}
                        label={localization.section}
                        onChange={(e) => {
                            item.section = e
                        }}
                    />
                    <DefaultSelect
                        itemCaption="title"
                        itemValue="value"
                        items={types}
                        label={localization.type}
                        onChange={(e) => {
                            item.type = e
                        }}
                    />
                    <FormikTextField
                        name="priority"
                        placeHolder={localization.priority}
                        label={localization.priority}
                        inputMode="number"
                        onChange={(e) => {
                            item.priority = e
                        }}
                    />
                </div>

                <div className="mt-10" dir="ltr">
                    <button className="w-1/4 bg-green-600 p-2 text-white rounded m-2" onClick={handleClick}>
                        {localization.add}
                    </button>
                    <button className="w-1/4 bg-gray-600 p-2 text-white rounded" onClick={handleCancel}>
                        {localization.cancel}
                    </button>
                </div>
            </div>
        </div>
    )
}

export default CategryPropertyModal
